import gql from 'graphql-tag';
import { attendanceTeamFragment } from './fragments';

export const insertAttendanceTeam = gql`
  mutation insertAttendanceTeam($attendanceTeam: AttendanceTeamInput!) {
    insertAttendanceTeam(attendanceTeam: $attendanceTeam) {
      ...attendanceTeamParts
    }
  }
  ${attendanceTeamFragment}
`;

export const updateAttendanceTeam = gql`
  mutation updateAttendanceTeam(
    $attendanceTeamId: Int!
    $attendanceTeam: AttendanceTeamInput!
  ) {
    updateAttendanceTeam(
      attendanceTeamId: $attendanceTeamId
      attendanceTeam: $attendanceTeam
    ) {
      ...attendanceTeamParts
    }
  }
  ${attendanceTeamFragment}
`;

export const deleteAttendanceTeam = gql`
  mutation deleteAttendanceTeam($attendanceTeamId: Int!) {
    deleteAttendanceTeam(attendanceTeamId: $attendanceTeamId)
  }
`;
